/**
 * Utility functions for form field rendering
 */

/**
 * Renders a field label with an asterisk if the field is required
 * @param {string} fieldName - The field name to display
 * @param {boolean} isRequired - Whether the field is required
 * @returns {JSX.Element} The label element with optional asterisk
 */
export const renderFieldLabel = (fieldName, isRequired = false) => {
  const displayName = fieldName.replace(/_/g, " ");

  return (
    <label className="block text-sm font-medium first-letter:uppercase">
      {displayName}:{isRequired && <span className="text-red-500 ml-1">*</span>}
    </label>
  );
};

/**
 * Renders a field label with an asterisk if the field is in the required fields array
 * @param {string} fieldName - The field name to display
 * @param {Array} requiredFields - Array of required field names
 * @returns {JSX.Element} The label element with optional asterisk
 */
export const renderFieldLabelWithRequired = (
  fieldName,
  requiredFields = []
) => {
  const isRequired = requiredFields.includes(fieldName);
  return renderFieldLabel(fieldName, isRequired);
};
